import templateUrl from 'emun.salesrep/salesrep-sales-goals-category-new.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesGoalsCategoryNewController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    $ctrl.orderByField = 'label';
    $ctrl.reverseSort = false;
    $ctrl.mode = "list";
    $ctrl.total = 0;
    $ctrl.repGroupFilter = '';
    $ctrl.label = $ctrl.title || "Categories";
    if ($ctrl.repGroup !== 'ALL') {
      $ctrl.repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
    }
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10
        }
      },
      elements: {
        rectangle: {
          borderWidth: 1
        }
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
          }
        }
      }
    };
    var context = $ctrl.context || 'rep';

    var filter = "SalesRepID";
    if (context === 'manager') { filter = "ManagerId"; }
    if (context === 'category') { filter = "CategoryId"; }
    if ($ctrl.context === 'executive') { filter = ''; }

    $ctrl.results = [];

    var salesQueryUrl = 'QuerySalesYOYWithCategoryTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear,TotalSalesLastYear&GroupBy=Category&OrderBy=Category';
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL') {
        salesQueryUrl = salesQueryUrl + '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    if (context === 'writingRep') {
      if ($ctrl.salesRepId) {
        salesQueryUrl = salesQueryUrl + '&SalesRepID=' + $ctrl.salesRepId;
        filter = '';
      }
      else {
        if ($ctrl.writingRepId) {
          salesQueryUrl = salesQueryUrl + '&WritingRepID=' + $ctrl.writingRepId;
          filter = '';
        }
      }
    }
    else {
      if (filter !== '') {
        salesQueryUrl = salesQueryUrl + '&' + filter + '=' + $ctrl.rep.id;
      }
    }
    if ($ctrl.insideSales === 'true') {
      salesQueryUrl = salesQueryUrl + '&IsInsideSales=true';
    }

    console.debug(salesQueryUrl);
    $ctrl.salesQuery = createAutoQuery({
      url: salesQueryUrl,
      pageSize: 1000,
      autoLoad: false,
      onLoaded: function (args) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        $ctrl.ytdTotal = 0;
        $ctrl.lastytdTotal = 0;
        $ctrl.lastyearTotal = 0;
        $ctrl.mtdTotal = 0;
        $ctrl.lastmtdTotal = 0;
        $ctrl.totalYearGoal = 0;
        $ctrl.totalMonthGoal = 0;

        args.results.forEach(function (sales) {
          if (sales.sumTotalSalesYearToDate > 0) {
            $ctrl.ytdTotal += sales.sumTotalSalesYearToDate;
          }
          if (sales.sumTotalSalesYearToDateLastYear > 0) {
            $ctrl.lastytdTotal += sales.sumTotalSalesYearToDateLastYear;
          }
          if (sales.sumTotalSalesLastYear > 0) {
            $ctrl.lastyearTotal += sales.sumTotalSalesLastYear;
          }
          if (sales.sumTotalSalesMonthToDate > 0) {
            $ctrl.mtdTotal += sales.sumTotalSalesMonthToDate;
          }
          if (sales.sumTotalSalesMonthToDateLastYear > 0) {
            $ctrl.lastmtdTotal += sales.sumTotalSalesMonthToDateLastYear;
          }
        });
        args.results.forEach(function (sales) {
          $ctrl.categories.results.forEach(function (v) {
            if (sales.category === v.label) {
              
              v.ytdTotal = sales.sumTotalSalesYearToDate;
              v.lastyearTotal = sales.sumTotalSalesLastYear;
              v.lastytdTotal = sales.sumTotalSalesYearToDateLastYear;
              v.mtdTotal = sales.sumTotalSalesMonthToDate;
              v.lastmtdTotal = sales.sumTotalSalesMonthToDateLastYear;
              v.monthGoal = 0;
              v.goal = 0;
              v.ytdGoal = 0;
              v.percent = 0;
              v.monthPercent = 0;
              v.ytdCategoryPercent = 0;
              v.lastyearCategoryPercent = 0;
              v.lastytdCategoryPercent = 0;
              v.ytdCategoryPercent = Math.round((v.ytdTotal / $ctrl.ytdTotal) * 100);
              //console.debug("cat info", v.label, v.ytdTotal, $ctrl.lastytdTotal);
              v.lastyearCategoryPercent = Math.round((v.ytdTotal / $ctrl.lastyearTotal) * 100);
              v.lastytdCategoryPercent = Math.round((v.ytdTotal / $ctrl.lastytdTotal) * 100);
              $ctrl.chartLabels.push(v.label);
              $ctrl.chartData.push(Math.round(v.ytdTotal));
              $ctrl.total += v.ytdTotal;
            }
          });
        });
        var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth&GroupBy=Category&OrderBy=Category';
        if ($ctrl.repGroup) {
          if ($ctrl.repGroup !== 'ALL') {
            salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
          }
        }
        //if (filter !== '') {
        //  salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
        //}
        if (context !== 'writingRep' && context !== 'executive') {
          if (filter !== '') {
            salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
          }
        }
        else {
          if ($ctrl.writingRepId) {
            salesGoalsUrl = salesGoalsUrl + '&WritingRep=' + $ctrl.writingRepId;
          }
        }
        if ($ctrl.insideSales === 'true') {
          // salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=true';
        }
        else {
          salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
        }

        if ((context === 'writingRep') || ($ctrl.insideSales === 'true')) {
          //do nothing because we have no goals per vendor for inside sales
        }
        else //standard
        {

          $ctrl.salesGoals = createAutoQuery({
            url: salesGoalsUrl,
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function (args) {
              
              args.results.forEach(function (goals) {
                $ctrl.categories.results.forEach(function (category, index) {
                  if (category.ytdTotal > 0 && category.label === goals.category) {
                    category.goal = goals.sumSalesGoalThisYear || 0;
                    category.monthGoal = goals.sumSalesGoalThisMonth || 0;
                    if (category.goal > 0) {
                      category.percent = Math.round((category.ytdTotal / category.goal) * 100);
                    } else {
                      category.percent = 0;
                    }
                    if (category.goal > 0) {
                      category.lastytdCategoryPercent = Math.round((category.ytdTotal / category.lastytdTotal) * 100);
                    } else {
                      category.lastytdCategoryPercent = 0;
                    }
                    if (category.monthGoal > 0) {
                      category.monthPercent = Math.round((category.mtdTotal / category.monthGoal) * 100);
                    } else {
                      category.monthPercent = 0;
                    }
                    $ctrl.totalYearGoal += category.goal;
                    $ctrl.totalMonthGoal += category.monthGoal;
                  }
                });
              });

              //remove empty records
            }
          });
        }
        $ctrl.isBusy = false;
      }
    });

    $ctrl.isBusy = true;
    var categoryUrl = '';
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL' && salesrepConfig.limitVendorByRepGroup) {
        categoryUrl = '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    $ctrl.categories = createAutoQuery({
      url: 'QueryProductCategories.json?IdNotIn=999' + categoryUrl,
      orderBy: 'Label',
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function (categories) {
        $ctrl.salesQuery.load(true);
      }
    });
  }
}

let SalesRepSalesGoalsCategoryNew = {
  bindings: {
    rep: '<',
    repGroup: '@',
    context: '@',
    title: '@',
    insideSales: '@',
    writingRepId: '@',
    salesRepId: '@'
  },
  controller: SalesRepSalesGoalsCategoryNewController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default SalesRepSalesGoalsCategoryNew